import React, { useEffect, useState, useCallback } from 'react'
import useStyles from './style'
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
  Typography,
  Tooltip,
} from '@mui/material'
import { ChevronLeft, Menu } from "@mui/icons-material";
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

import list from '../../Model/MenuList'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toggleSidebar, closeSidebar } from '../../Redux/Sidebar/actions'
import { CUSTOM_CONSTANTS } from "Constants";
import settingsApi from "Services/Settings";
import _ from "lodash";
// Redux
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { setNewSiteLogo } from "../../Redux/SiteSettings/actions";

const Sidebar = ({ profileDetails }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const dispatch = useDispatch();
  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const classes = useStyles({ sidebarOpen })
  const [selectedIndex, setSelectedIndex] = useState(pathname)
  const [menuList, setMenuList] = useState(list)
  const [values, setValues] = useState([]);

  const siteNewL = useSelector(
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );

  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const getFilteredMenuList = () => menuList.filter((menu) => menu.for.includes(userType) && (!menu.hideForDemoAccount || !demoaccount_id));

  const handleClick = (index, openState) => {
    const filtered = getFilteredMenuList();
    const item = filtered[index];
    const updatedMenuList = menuList.map((data) => {
      if (data?.isCollapsible) {
        if (data.name === item?.name) {
          return { ...data, open: !openState, active: true }
        } else {
          return { ...data, open: false, active: false }
        }
      } else if (data?.link === selectedIndex) {
        return { ...data, open: openState, active: openState }
      } else {
        return { ...data, open: false, active: false }
      }
    })
    setMenuList(updatedMenuList)
  }

  const getMasterValues = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    setSelectedIndex(pathname)
    getMasterValues();
  }, [pathname, siteNewL, getMasterValues])

  const handleMenuNavigate = (link) => {
    navigate(link)
    if (window.innerWidth < 960) {
      dispatch(closeSidebar());
    }
  }

  // To Open the Active menu Collapsible True when submenu is active
  useEffect(() => {
    let currentArrObj = null
    const currentObjInMainArr = menuList?.find(
      (data) => data?.link === pathname
    )
    if (currentObjInMainArr) {
      currentArrObj = currentObjInMainArr
    } else {
      const currentObjInSubArr = menuList?.find((data) =>
        data?.subMenu?.find((item) => item?.subLink === pathname)
      )
      currentArrObj = currentObjInSubArr
    }
    const updatedMenuList = menuList?.filter((menu) => menu.for.includes(userType) && (!menu.hideForDemoAccount || !demoaccount_id)).map((data) =>
      data?.name === currentArrObj?.name
        ? { ...data, open: true, active: true }
        : { ...data, open: false, active: false }
    )
    setMenuList(updatedMenuList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div className={classes.root}>
      {/* Floating edge toggle button */}
      <div className={classes.toggleButton} onClick={handleToggleSidebar}>

        <Menu className={classes.toggleIcon} />

      </div>

      {/* Corporate Brand Header */}
      <div className={classes.brandHeader}>
        <div className={classes.brandLogoCont} onClick={() => handleMenuNavigate("/")}>
          <img
            src={
              !_.isEmpty(profileDetails?.image)
                ? `${profileDetails?.image}`
                : "/assets/images/Admindefaultimg.png"
            }
            alt={profileDetails?.user_name || "Admin"}
            className={classes.logo}
          />
          {sidebarOpen && (
            <Typography className={classes.brandName} variant="h6">
              {profileDetails?.user_name || "Admin Panel"}
            </Typography>
          )}
        </div>
      </div>

      {/* Scrollable Navigation Menu */}
      <section className={classes.menuListContainer}>
        {menuList?.filter((menu) => menu.for.includes(userType) && (!menu.hideForDemoAccount || !demoaccount_id))
          .map((data, idx) => (
            <List
              key={data?.name}
              component="nav"
              aria-label="navMenu"
              disablePadding
              onClick={() => {
                if (data?.name === "Sign Out") {
                  localStorage.clear();  // Clear storage
                  navigate(0); // Reload to reset state
                }
                data?.isCollapsible === false && handleMenuNavigate(data?.link)
              }}
            >
              <Tooltip
                title={data?.name}
                placement="right"
                disableHoverListener={sidebarOpen}
                arrow
              >
                <ListItemButton
                  className={`${classes.listItemButton} ${data?.active === true ? classes.listItemActive : ""}`}
                  selected={data?.active === true}
                  onClick={() => {
                    handleClick(idx, data?.open)
                  }}
                >
                  <ListItemIcon className={!sidebarOpen ? classes.menuIconCentered : classes.menuIcon}>
                    {data.src && <img src={data.src} alt="sidebar_icons" />}
                    {data.icon && <data.icon />}
                  </ListItemIcon>
                  <ListItemText
                    primary={data?.name}
                    className={
                      data?.active === true
                        ? classes.menuLabels
                        : classes.menuLabels2
                    }
                    sx={{
                      opacity: sidebarOpen ? 1 : 0,
                      maxWidth: sidebarOpen ? 180 : 0,
                      overflow: "hidden",
                      transition: "opacity 0.25s ease, max-width 0.35s ease",
                      whiteSpace: "nowrap",
                    }}
                  />
                  {/* Accordion Icon */}
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      opacity: sidebarOpen ? 1 : 0,
                      transition: "opacity 0.25s ease",
                      marginLeft: 2,
                    }}
                  >
                    {data?.isCollapsible ? (
                      data?.open ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : null}
                  </span>
                </ListItemButton>
              </Tooltip>

              {/* Accordion Collapse */}
              {data?.isCollapsible === true && (
                <Collapse in={data?.open} timeout="auto" unmountOnExit>
                  {data?.subMenu?.filter((sub) => sub.for.includes(userType)).map((item, subIdx) => (
                    <div key={item?.name}>
                      <List
                        component="div"
                        disablePadding
                        onClick={() => {
                          if (item?.isCollapsible) {
                            const updatedMenuList = [...menuList];
                            const menuIndex = menuList.findIndex(menu => menu.name === data.name);
                            if (menuIndex !== -1) {
                              updatedMenuList[menuIndex].subMenu[subIdx].open = !item.open;
                              setMenuList(updatedMenuList);
                            }
                          } else {
                            handleMenuNavigate(item?.subLink);
                          }
                        }}
                        className={classes.subMenuLabel}
                        sx={selectedIndex === item?.subLink ? { background: '#c1c1c16b' } : {}}
                      >
                        <Tooltip
                          title={item?.name}
                          placement="right"
                          disableHoverListener={sidebarOpen}
                          arrow
                        >
                          <ListItemButton className={classes.subitemscolor}>
                            <ListItemIcon className={classes.subitemsicon}>
                              {item.src && <img src={item.src} alt="sidebar_icons" />}
                              {item.icon && <item.icon />}
                            </ListItemIcon>
                            <ListItemText
                              className={classes.subitemscontent}
                              primary={<Typography variant="body1">{item?.name}</Typography>}
                              sx={{
                                opacity: sidebarOpen ? 1 : 0,
                                maxWidth: sidebarOpen ? 180 : 0,
                                overflow: "hidden",
                                transition: "opacity 0.25s ease, max-width 0.35s ease",
                                whiteSpace: "nowrap",
                              }}
                            />
                            {item?.isCollapsible ? (
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  opacity: sidebarOpen ? 1 : 0,
                                  transition: "opacity 0.25s ease",
                                }}
                              >
                                {item?.open ? <ExpandLess /> : <ExpandMore />}
                              </span>
                            ) : null}
                          </ListItemButton>
                        </Tooltip>
                      </List>

                      {/* Recursive collapse for nested submenu */}
                      {item?.isCollapsible && (
                        <Collapse in={item?.open} timeout="auto" unmountOnExit>
                          {item?.subMenu?.map((subSub) => (
                            <List
                              component="div"
                              disablePadding
                              key={subSub?.name}
                              onClick={() => handleMenuNavigate(subSub?.subLink)}
                              sx={selectedIndex === subSub?.subLink ? { background: '#c1c1c16b' } : {}}
                            >
                              <Tooltip
                                title={subSub?.name}
                                placement="right"
                                disableHoverListener={sidebarOpen}
                                arrow
                              >
                                <ListItemButton className={classes.subitemscolor}>
                                  <ListItemIcon className={classes.subitemsicon}>
                                    {subSub.src && <img src={subSub.src} alt="sidebar_icons" />}
                                  </ListItemIcon>
                                  {sidebarOpen && (
                                    <ListItemText
                                      className={classes.subitemscontent}
                                      primary={<Typography variant="body2">{subSub?.name}</Typography>}
                                    />
                                  )}
                                </ListItemButton>
                              </Tooltip>
                            </List>
                          ))}
                        </Collapse>
                      )}
                    </div>
                  ))}
                </Collapse>
              )}
            </List>
          ))}
      </section>
    </div>
  )
}

export default Sidebar


